export default "__VITE_ASSET__86ab627a__"